import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { onEnter } from '../../utils'
import { DiscountPerWeek } from './components/BlackFridayBanner/DiscountPerWeek'

type PromoBannerProps = {
  applyDiscount: () => void
}

export function BlackFridayPromoBanner({
  applyDiscount,
}: React.PropsWithChildren<PromoBannerProps>) {
  return (
    <Box
      alignItems={AlignItems.Center}
      bg={Color.ColdGrey_900}
      color={Color.White}
      display={Display.Flex}
      justifyContent={[JustifyContent.Center]}
      onClick={applyDiscount}
      onKeyDown={onEnter(applyDiscount)}
      paddingH={[4, null, 6, 8, 10]}
      paddingV={4}
      role="button"
      tabIndex={0}
      aria-label="Apply Black Friday discount"
      width="100%"
    >
      <Box flexGrow={1} />
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        gap={2}
      >
        <Body2 fontWeight={FontWeight.Bold} size={2} color={Color.White}>
          Black Friday sale now on<sup>**</sup>
        </Body2>
        <DiscountPerWeek />
      </Box>
      <Box flexGrow={1} />
      <Box>
        <Icon name="arrow_right" variant={IconVariant.Inherit} />
      </Box>
    </Box>
  )
}
